function toggleClassOfEventTarget(e, clazz) {

    if (hasClassInEventTarget(e, clazz)) {
        removeClassToEventTarget(e, clazz);
    } else {
        addClassToEventTarget(e, clazz);
    }

}

function addClassToEventTarget(e, clazz) {

    let target = e.target;

    if (target.classList) {
        target.classList.add(clazz);
    } else {
        target.className += ' ' + clazz;
    }
}


function removeClassToEventTarget(e, clazz) {

    let target = e.target;

    if (target.classList) {
        target.classList.remove(clazz);
    } else {
        target.className = target.className.replace(' ' + clazz, '');
    }
}


function hasClassInEventTarget(e, clazz) {
    let target = e.target;

    if (target.classList) {
        return target.classList.contains(clazz);
    } else {
        return target.className.indexOf(clazz) !== -1;
    }
}